// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountConsolidation } from './account-consolidation';
import { AccountConsolidationDecision } from './account-consolidation-decision';
import { AccountConsolidationItemType } from './account-consolidation-item-type';
import { ProximityUser } from './proximity-user';
import { AccountConsolidationDecisionEnum } from './enums';
import { AccountConsolidationItemTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountConsolidationItem extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK accountConsolidationDecision */
  accountConsolidationDecisionId!: AccountConsolidationDecisionEnum;
  /** Guid FK accountConsolidation */
  accountConsolidationId!: string;
  /** Enum FK accountConsolidationItemType */
  accountConsolidationItemTypeId!: AccountConsolidationItemTypeEnum;
  /** String(250) */
  note?: string;
  /** Guid FK proximityUser */
  proximityUserId?: string;
  /** Binary */
  rowVersion!: any;
  /** Guid */
  sourceEntityId?: string;
  /** Guid */
  targetEntityId?: string;
  /** FK accountConsolidationId */
  accountConsolidation!: AccountConsolidation;
  /** FK accountConsolidationDecisionId */
  accountConsolidationDecision!: AccountConsolidationDecision;
  /** FK accountConsolidationItemTypeId */
  accountConsolidationItemType!: AccountConsolidationItemType;
  /** FK proximityUserId */
  proximityUser!: ProximityUser;
}

